const permissionsSchema = {
    type: "object",
    additionalProperties: true,
    required: ["controlPtzf", "controlPresets", "speakerTalkdown", "quickSounds", "suspendPatrol"],
    properties: {
        controlPtzf: { type: "boolean" },
        controlPresets: { type: "boolean" },
        speakerTalkdown: { type: "boolean" },
        quickSounds: { type: "boolean" },
        suspendPatrol: { type: "boolean" },
    },
};

const capabilitiesPropertiesSchema = {
    autofocus: { type: "boolean" },
    clickToCenter: { type: "boolean" },
    heater: { type: "boolean" },
    home: { type: "boolean" },
    lightInternal: { type: "boolean" },
    lightInfared: { type: "boolean" },
    pan: { type: "boolean" },
    panStop: { type: "boolean" },
    position: { type: "boolean" },
    relayActions: {
        type: "array",
        items: {
            type: "object",
            additionalProperties: true,
            required: ["relayName", "uiLabel", "stateDefault", "reportStates"],
            properties: {
                relayName: { type: "string" },
                uiLabel: { type: ["string", "null"] },
                stateDefault: { type: ["boolean", "null"] },
                reportStates: { type: "boolean" },
                delay: { type: ["number", "null"] },
            },
        },
    },
    speakerSounds: {
        type: "array",
        items: {
            type: "object",
            additionalProperties: true,
            required: ["id", "label"],
            properties: {
                id: { type: "integer" },
                label: { type: "string" },
            },
        },
    },
    speakerTalkdown: { type: "boolean" },
    snapshot: { type: "boolean" },
    zoom: { type: "boolean" },
    // TODO: Add webrtc property. Waiting to include to avoid integration issues.
    // webrtc: { type: "boolean" }
};

export const capabilitiesSchema = {
    type: "object",
    additionalProperties: true,
    required: Object.keys(capabilitiesPropertiesSchema),
    properties: capabilitiesPropertiesSchema,
};

export const cameraHealthPropertiesSchema = {
    isFlapping: { type: "boolean" },
    isGradient: { type: "boolean" },
    statusText: { type: "string" },
    startColor: { type: "string" },
    color: { type: "string" },
    overlay: { type: ["string", "null"] },
};

export const cameraHealthSchema = {
    type: "object",
    additionalProperties: true,
    required: Object.keys(cameraHealthPropertiesSchema),
    properties: cameraHealthPropertiesSchema,
};

const fetchStreamMetadataPropertiesSchema = {
    cameraId: { type: "integer" },
    cameraName: { type: ["string", "null"] },
    cameraActive: { type: "boolean" },
    cameraPatrolSuspended: { type: "boolean" },
    cameraHealth: cameraHealthSchema,
    capabilities: capabilitiesSchema,
    liveUnitId: { type: "integer" },
    liveUnitName: { type: "string" },
    sipPhoneNumber: { type: ["string", "null"] },
    sipPin: { type: ["string", "null"] },
    clientPasscode: { type: ["number", "null"] },
    locationId: { type: "integer" },
    locationName: { type: "string" },
    clientId: { type: "integer" },
    clientName: { type: "string" },
    clientLogoUrl: { type: ["string", "null"] },
    otherCameraIds: { type: "array", items: { type: "integer" } },
    timeZone: { type: "string" },
    permissions: permissionsSchema,
    presets: {
        type: "array",
        items: {
            type: "object",
            required: ["id", "name"],
            additionalProperties: true,
            properties: {
                id: { type: "integer" },
                name: { type: "string" },
                isHome: { type: "boolean" },
            },
        },
    },
    thumbnailPreset: { type: ["number", "null"] },
};

export const fetchStreamMetadataSchema = {
    type: "object",
    required: ["status", "statusMessage", "data"],
    properties: {
        status: { const: 200 },
        statusMessage: { type: "string" },
        data: {
            type: "object",
            additionalProperties: true,
            required: Object.keys(fetchStreamMetadataPropertiesSchema),
            properties: fetchStreamMetadataPropertiesSchema,
        },
    },
    additionalProperties: true,
};
